import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, VStack, Heading, Button, HStack } from '@chakra-ui/react';
import { useAuthStore } from '@/stores/authStore';
import { useMatingRecordStore } from '@/stores/matingRecordStore';
import { AppLayout } from '@/components/layout/AppLayout';
import { MatingRecordForm } from '@/components/matingRecord/MatingRecordForm';

/**
 * 交配記録登録・編集ページコンポーネント
 */
const MatingRecordFormPage: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { user } = useAuthStore();
  const { selectedMatingRecord, fetchMatingRecord } = useMatingRecordStore();

  const isEditMode = !!id;

  useEffect(() => {
    if (isEditMode && user && id) {
      fetchMatingRecord(id, user.uid);
    }
  }, [isEditMode, user, id, fetchMatingRecord]);

  /**
   * フォーム送信成功時の処理
   */
  const handleSubmitSuccess = () => {
    navigate('/dogs'); // 個体一覧に戻る（後で専用の交配記録一覧ページに変更可能）
  };

  /**
   * キャンセル処理
   */
  const handleCancel = () => {
    navigate(-1);
  };

  // 認証ガードはルート側の ProtectedRoute が担うため、ここでは user は必ず存在する。
  if (!user) return null;

  return (
    <AppLayout>
      <Box maxW="4xl" mx="auto">
        <VStack gap={6} align="stretch">
          {/* ヘッダー */}
          <HStack justify="space-between" flexWrap="wrap" gap={4}>
            <Heading size="xl">{isEditMode ? '交配記録編集' : '交配記録新規登録'}</Heading>
            <HStack gap={2}>
              <Button variant="outline" onClick={handleCancel}>
                キャンセル
              </Button>
            </HStack>
          </HStack>

          {/* フォーム */}
          <Box bg="white" p={8} borderRadius="lg" shadow="md">
            <MatingRecordForm
              userId={user.uid}
              initialData={
                isEditMode && selectedMatingRecord
                  ? {
                      id: selectedMatingRecord.id,
                      maleId: selectedMatingRecord.maleId,
                      femaleId: selectedMatingRecord.femaleId,
                      matingDate: selectedMatingRecord.matingDate.toDate(),
                    }
                  : undefined
              }
              onSubmitSuccess={handleSubmitSuccess}
              onCancel={handleCancel}
            />
          </Box>
        </VStack>
      </Box>
    </AppLayout>
  );
};

export default MatingRecordFormPage;
